import React from 'react';
import PropTypes from 'prop-types';
import Mutation from '../../../../../Apollo/Mutation';
import ValidateResetPasswordTokenMutation from './ValidateResetPasswordTokenMutation';

class ValidateResetPasswordTokenConnectorApollo extends React.Component {
    static propTypes = {
        children: PropTypes.func.isRequired,
    };

    createValidateToken = mutate => async request => {
        const variables = request;

        const response = await mutate({
            variables,
        });

        return response;
    };

    render() {
        const { children } = this.props;

        return (
            <Mutation mutation={ValidateResetPasswordTokenMutation}>
                {mutate =>
                    children({
                        validateToken: this.createValidateToken(mutate),
                    })
                }
            </Mutation>
        );
    }
}

export default ValidateResetPasswordTokenConnectorApollo;
